import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CampaignFilterBody = _resolveComponent("CampaignFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "campaigns",
    ref: "campaignFilterItem",
    icon: "TrendingUpIcon",
    title: $options.getCampaignTitle,
    selectedTitle: $options.getCampaignSelectedTitle,
    selectedCount: $props.campaigns?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_CampaignFilterBody, {
      title: "Campaign",
      selected: $props.campaigns?.filterState?.selected,
      isModified: $props.campaigns.isModified,
      pendingChanges: $props.campaigns.pendingChanges,
      isSearching: $props.campaigns.isSearching,
      keyword: $props.campaigns.keyword,
      list: $props.campaigns.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.campaigns.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: $options.onApply,
      onSearch: $options.handleCampaignSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.campaignFilterItem?.closeDropdown
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}